(function () {
  function addStyle() {
    if (document.getElementById('vk-sticky-cod-hotfix-style')) return;
    var style = document.createElement('style');
    style.id = 'vk-sticky-cod-hotfix-style';
    style.textContent = [
      '.sticky-atc-bar .product-form__buttons{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:.8rem!important;width:100%!important;}',
      '.sticky-atc-bar .product-form__button-dynamic,.sticky-atc-bar .vk-releasit-buy-now{display:block!important;min-width:0!important;}',
      '.sticky-atc-bar .product-form__submit,.sticky-atc-bar button.vk-releasit-fallback-button{min-height:4.8rem!important;padding-inline:1rem!important;font-size:clamp(1.2rem,3.35vw,1.4rem)!important;line-height:1.15!important;white-space:normal!important;}',
      'button.vk-releasit-fallback-button{width:100%!important;border:1px solid #111827!important;border-radius:var(--buttons-radius,999px)!important;background:#111827!important;color:#fff!important;box-shadow:0 14px 28px rgba(17,24,39,.18)!important;font:inherit!important;font-weight:900!important;letter-spacing:0!important;text-transform:none!important;}',
      '.vk-releasit-buy-now:has(._rsi-cod-form-gempages-button-hook :is(button,a,[role=button],input[type=button],input[type=submit])) .vk-releasit-fallback-button{display:none!important;}',
      'body:has(cart-drawer[open]) .sticky-atc-bar,body:has(cart-drawer[active]) .sticky-atc-bar{display:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureStickyCodFallback() {
    addStyle();
    document.querySelectorAll('.sticky-atc-bar .product-form__button-dynamic').forEach(function (slot) {
      if (slot.querySelector('[data-vk-releasit-fallback]')) return;
      var wrapper = slot.querySelector('[data-vk-releasit-buy-now]') || slot;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'vk-releasit-fallback-button';
      button.setAttribute('data-vk-releasit-fallback', '');
      button.textContent = 'COD Order';
      wrapper.appendChild(button);
    });
  }

  function bindFallbackClick() {
    if (window.__vkStickyCodHotfixBound) return;
    window.__vkStickyCodHotfixBound = true;
    document.addEventListener('click', function (event) {
      var fallbackButton = event.target.closest && event.target.closest('[data-vk-releasit-fallback]');
      if (!fallbackButton) return;
      event.preventDefault();

      var buttons = Array.prototype.slice.call(
        document.querySelectorAll(
          '.section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook button, .section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook a, .section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook [role=button], .section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook input[type=button], .section-main-product .main-product-form [data-vk-releasit-buy-now] ._rsi-cod-form-gempages-button-hook input[type=submit]'
        )
      );

      var mainButton = buttons.find(function (button) {
        var box = button.getBoundingClientRect();
        var styles = window.getComputedStyle(button);
        return box.width > 0 && box.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
      });

      if (mainButton) {
        mainButton.click();
        return;
      }

      var mainForm = document.querySelector('.section-main-product .main-product-form');
      if (mainForm) mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() {
    bindFallbackClick();
    ensureStickyCodFallback();
    window.setTimeout(ensureStickyCodFallback, 800);
    window.setTimeout(ensureStickyCodFallback, 2200);
    window.setTimeout(ensureStickyCodFallback, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
